import simpleModal from './simpleModal.js';
import dropdown from './dropdown.js';
import confirmDialog from './confirmDialog.js';
import datePicker from './datePicker.js';
import fineDatePicker from './fineDatePicker.js';
import yearPicker from './yearPicker.js';
import miniCalendar from './miniCalendar.js';
import mailFormModal from './mailFormModal.js';
import smsForm from './smsForm.js';
import smsPopupForm from './smsPopupForm.js';
import noteFormModal from './noteFormModal.js';
import noteBadge from './noteBadge.js';
import mobileSheet from './mobileSheet.js';
import listMore from './listMore.js';
import mobileNoteSheet from './mobileNoteSheet.js';
import exportDownload from './exportDownload.js';
import mWorkForm from './mWorkForm.js';
import mTimesheetForm from './mTimesheetForm.js';

export default function registerComponents(Alpine) {
    Alpine.data('simpleModal', simpleModal);
    Alpine.data('dropdown', dropdown);
    Alpine.data('confirmDialog', confirmDialog);
    Alpine.data('datePicker', datePicker);
    Alpine.data('fineDatePicker', fineDatePicker);
    Alpine.data('yearPicker', yearPicker);
    Alpine.data('miniCalendar', miniCalendar);   // MY일정 좌측 인라인 달력(2026-09-22)
    Alpine.data('mailFormModal', mailFormModal);
    Alpine.data('smsForm', smsForm);
    Alpine.data('smsPopupForm', smsPopupForm);
    Alpine.data('noteFormModal', noteFormModal);
    Alpine.data('noteBadge', noteBadge);
    // 모바일 뷰(/m/**) 전용
    Alpine.data('mobileSheet', mobileSheet);
    Alpine.data('listMore', listMore);
    Alpine.data('mobileNoteSheet', mobileNoteSheet);
    // 모바일 등록/수정 폼(Phase G, 2026-09-18) — fetch 는 $mapi(plugins/mobileApi.js)
    Alpine.data('mWorkForm', mWorkForm);
    Alpine.data('mTimesheetForm', mTimesheetForm);
    // 목록 PDF/Excel 내보내기(fragments/export-modal.html 과 짝) — 2026-09-14 C-H5
    Alpine.data('exportDownload', exportDownload);
}
